export default __webpack_public_path__ + "static/media/loader.ef9814c8.gif";